import React from 'react';
import { Link } from 'react-router-dom';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { Button } from '../components/ui/button';

const faqs = [
  {
    question: "Is it spicy?",
    answer: "Country Bo blends are not heat-focused. We're all about bold, complex flavor—not just making your mouth burn. Our seasonings bring depth, savoriness, and character to your dishes. If you want to add heat, that's your call!"
  },
  {
    question: "What's best for seafood?",
    answer: "Our Seafood Seasoning (Coastal Savory Blend) is specifically crafted for fish, shrimp, crab, and all things from the sea. It's bright, savory, and coastal—perfect for frying, baking, boils, and grilling. It's also amazing on fries and corn!"
  },
  {
    question: "How do I use each blend?",
    answer: "Each blend has a suggested usage range: Light (subtle finish), Medium (everyday bold flavor), and Heavy (full-on flavor punch). Start with medium and adjust to your taste. You can season before cooking, during, or as a finishing touch."
  },
  {
    question: "What are the shipping times?",
    answer: "We ship orders within 1-2 business days. Standard shipping typically takes 3-5 business days depending on your location. Expedited shipping options are available at checkout."
  },
  {
    question: "What's your return/refund policy?",
    answer: "We want you to love your blends! If you're not satisfied, contact us within 30 days of delivery. We'll work with you to make it right—whether that's a replacement or refund. See our full Refund Policy for details."
  },
  {
    question: "How do I contact support?",
    answer: "You can reach us through our Contact page, or email us directly. We typically respond within 24-48 hours on business days. For wholesale inquiries, please note that in your message."
  },
  {
    question: "Are your seasonings gluten-free?",
    answer: "Please check the ingredient list on each product page for specific dietary information. If you have allergies or dietary restrictions, feel free to contact us for detailed ingredient information."
  },
  {
    question: "Can I use these blends for meal prep?",
    answer: "Absolutely! Our Herb & Savory blend is perfect for meal prep. Season your proteins and veggies in bulk, and enjoy bold flavor all week long. The consistent flavor profile makes batch cooking easy."
  }
];

export const FAQPage = () => {
  return (
    <div className="min-h-screen bg-[#FAF8F5]" data-testid="faq-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <h1 className="font-['Bodoni_Moda'] text-4xl sm:text-5xl font-bold text-[#2A2A2A] mb-4 text-center">
          Frequently Asked Questions
        </h1>
        <p className="text-[#666] text-center mb-12">
          Got questions? We've got answers.
        </p>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-white rounded-xl border border-[#E5E0D8] px-6 data-[state=open]:shadow-sm"
              data-testid={`faq-item-${index}`}
            >
              <AccordionTrigger className="text-left font-semibold text-[#2A2A2A] hover:no-underline py-5">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-[#666] pb-5">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-12 text-center">
          <p className="text-[#666] mb-4">Still have questions?</p>
          <Link to="/contact">
            <Button
              variant="outline"
              className="border-[#2A2A2A] text-[#2A2A2A] hover:bg-[#2A2A2A] hover:text-white"
              data-testid="contact-cta"
            >
              Contact Us
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
